import script from "./CreateFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFeed.vue?vue&type=script&setup=true&lang=js"

import "./CreateFeed.vue?vue&type=style&index=0&id=f41b46be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f41b46be"]])

export default __exports__